import { ForgotPasswordForm } from "./ForgotPasswordForm";

/**
 * ForgotPasswordPage Component
 * Page-level component that composes views
 */
export const ForgotPasswordPage = () => {
  return <ForgotPasswordForm />;
};
